import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Card, Col, Row } from 'antd'
import moment from 'moment'
import ScrollBar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

const NotificationList = (props) => {
  const [selected, setSelected] = useState(undefined)

  const renderNotification = (notification) => {
    var sel = notification._id == selected?._id
    return (
      <Row
        className='not-container'
        style={{
          boxShadow:
            '0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)',
        }}
      >
        <Col flex={'auto'}>
          <Row className='not-Header' align='middle'>
            <Col className='nt-header'>{notification.header}</Col>
            <Col style={{ fontSize: 10, marginLeft: 'auto' }}>
              {moment(notification.date).format('MM/DD/YY hh:mm a')}
            </Col>
          </Row>
          <Row className={sel ? 'not-descp' : 'not-descp descp-wrap'}>
            {notification.message}
          </Row>
          <Row style={{ fontSize: 12, marginTop: 5 }} hidden={!sel}>
            <Col flex={'94px'}>
              {' '}
              <b>Delievered on:</b>{' '}
            </Col>
            <Col>
              {' '}
              <i>{moment(notification.date).format('MM/DD/YY hh:mm a')}</i>{' '}
            </Col>
          </Row>
          <Row style={{ fontSize: 12 }} hidden={!sel}>
            <Col flex={'94px'}>
              {' '}
              <b>Received on:</b>{' '}
            </Col>
            <Col flex='auto'>
              <i>
                {notification.delieveredat
                  ? moment(notification.delieveredat).format('MM/DD/YY hh:mm a')
                  : 'NA'}
              </i>
            </Col>
          </Row>
          <Row style={{ fontSize: 12 }} hidden={!sel}>
            <Col flex={'94px'}>
              {' '}
              <b>Read on:</b>{' '}
            </Col>
            <Col>
              <i>
                {notification.readat
                  ? moment(notification.readat).format('MM/DD/YY hh:mm a')
                  : 'NA'}
              </i>
            </Col>
          </Row>
          <Row style={{ fontSize: 12 }} hidden={!sel}>
            <Col flex={'94px'}>
              {' '}
              <b>Sender:</b>{' '}
            </Col>
            <Col>
              <i>
                {notification.sender
                  ? notification.sender.firstname +
                    ' ' +
                    notification.sender.lastname
                  : 'NA'}
              </i>
            </Col>
          </Row>
          <Row justify='start' align='middle'>
            <Col
              className='not-more-btn'
              onClick={() => setSelected(sel ? undefined : notification)}
            >
              <i>{sel ? 'less' : 'more'}</i>
            </Col>
            <Col style={{ marginLeft: 'auto', height: 20 }}>
              {notification.readat || notification.delieveredat ? (
                <svg
                  width='20px'
                  height='20px'
                  stroke='white'
                  fill={notification.readat ? '#1890ff' : 'grey'}
                  focusable='false'
                  viewBox='0 0 24 24'
                  aria-hidden='true'
                  tabindex='-1'
                  title='DoneAll'
                >
                  <path d='M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' />
                </svg>
              ) : (
                <svg
                  width='20px'
                  stroke='white'
                  height='20px'
                  fill={'grey'}
                  focusable='false'
                  viewBox='0 0 24 24'
                  aria-hidden='true'
                  tabindex='-1'
                  title='Done'
                >
                  <path d='M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' />
                </svg>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <Row style={{ width: '100%' }}>
      <ScrollBar style={{ height: 527, width: '100%' }}>
        <Col flex='auto' style={{ overflowY: 'auto', padding: 5 }}>
          {props.notifications.map((notification) =>
            renderNotification(notification)
          )}
        </Col>
      </ScrollBar>
    </Row>
  )
}

NotificationList.propTypes = {
  patient: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
  }
}

export default connect(mapStateToProps, null)(NotificationList)
